export default class RestLinkError extends Error {
  __internalError: boolean;

  constructor(message: string) {
    super(message);
    this.__internalError = true;
  }
}
